export default (state = { data: [], selectedItem: null }, action) => {
  switch (action.type) {
    case 'fetch_report_config_list_start':
      return state;

    case 'fetch_report_config_list_success':
      return { ...state, data: action.payload };

    case 'fetch_report_config_list_error':
      return state;

    case 'fetch_report_config_item_start':
      return { ...state, selectedItem: null };

    case 'fetch_report_config_item_success':
      return { ...state, selectedItem: action.payload };

    case 'fetch_report_config_item_error':
      return { ...state, selectedItem: null };

    default:
      return state;
  }
};